(() => {
  const dialog = document.getElementById('MRWelcome');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const tab = document.querySelector('[data-mr-welcome-open]');
  let previousFocus;
  const seenKey = 'mr-welcome-dismissed-v1';
  const successKey = 'mr-welcome-subscribed-v1';
  const getStored = key => { try { return localStorage.getItem(key); } catch { return null; } };
  const save = (key, value) => { try { localStorage.setItem(key, value); } catch {} };
  const isSuccess = !!dialog.querySelector('[data-mr-welcome-success]');
  const open = () => {
    if (dialog.open) return;
    previousFocus = document.activeElement;
    dialog.showModal();
  };
  const close = () => { dialog.close(); };
  tab?.addEventListener('click', open);
  dialog.querySelectorAll('[data-mr-welcome-close]').forEach(button => button.addEventListener('click', close));
  dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(); } });
  dialog.addEventListener('close', () => { save(seenKey, String(Date.now())); previousFocus?.focus(); });
  if (isSuccess) save(successKey, '1');
  if (getStored(successKey) && !isSuccess && tab) tab.hidden = true;
  if (isSuccess || dialog.querySelector('[data-mr-welcome-error]')) open();
  else if (!getStored(successKey) && Date.now() - Number(getStored(seenKey) || 0) > 604800000 && !window.Shopify?.designMode) {
    let checks = 0;
    const tryOpen = () => {
      const cookieBanner = document.getElementById('shopify-pc__banner');
      const blocked = document.querySelector('cart-drawer.active, dialog[open]') || (cookieBanner && cookieBanner.getClientRects().length);
      if (!blocked) open();
      else if (++checks < 60) setTimeout(tryOpen, 1000);
    };
    setTimeout(tryOpen, 5000);
  }
})();
